/**
 * Wire contract for the admin order ACTION surface (AUT-112 /
 * PHASE-B-API-1):
 *
 *   - `POST /admin/orders/:id/force-cancel` → request body `AdminForceCancelInput`
 *
 * Centralised in `@carcheck/shared` so the api Zod schema + the admin SPA
 * form import the same source of truth — no api↔admin mirror drift.
 *
 * Force-cancel is a destructive admin override gated by a fresh TOTP
 * step-up token (`x-totp-step-up` header) on the api side. The admin
 * EXPLICITLY picks the refund policy here rather than inheriting the
 * customer time-band auto-calc; the chosen policy threads into the
 * `order.cancelled` domain event so the Payments (refund) + Payouts
 * (scheduled-payout cancel / travel-fee partial) listeners execute the
 * money moves. Orders never moves money directly.
 */
/**
 * Refund policy the admin picks on a force-cancel. Mirror of the api-side
 * `RefundPolicy` union (`packages/api/.../dto/refund-plan.dto.ts`):
 *
 *   - `full`               — customer gets the full `total` back; inspector
 *                            gets nothing.
 *   - `partial_travel_fee` — customer gets `total − travelFee`; inspector
 *                            keeps the travel fee.
 *   - `none`               — no refund; inspector keeps earnings
 *                            (`subtotal − platformFee`).
 *
 * Wire-stable: renaming / removing a value is a breaking change that must
 * be coordinated across api + admin.
 */
export const ADMIN_REFUND_POLICIES = ['full', 'partial_travel_fee', 'none'];
//# sourceMappingURL=admin-order-actions.js.map